// 角色管理
import http from "@/jslibs/axios/http";

// 新增角色
export const add = (data) => http.post("/web/permissionManager/addSysRole", data);

// 编辑角色
export const edit = (data) => http.post("/web/permissionManager/updateSysRole", data);

// 角色详情
export const detail = (data) => http.post("/web/permissionManager/getSysRoleDetail", data);

// 角色分页列表
export const page = (data) => http.post("/web/permissionManager/getSysRoleList", data);

// 角色删除
export const del = (data) => http.post("/web/permissionManager/deleteSysRole", data);
